import { type CustomTemplateScope, type TemplateScope } from '../../../models/TemplateLibrary'

export interface DuplicateScopeContext {
  hasTemplateAdminScope: boolean
  templateScope: TemplateScope
  originContext?: { meetingTemplateId?: string; userId?: string }
}

export const computeDefaultDuplicateScope = ({ hasTemplateAdminScope, templateScope, originContext }: DuplicateScopeContext): CustomTemplateScope => {
  if (!hasTemplateAdminScope) return 'user'
  const cameFromMeetingTemplateRow = Boolean(originContext?.meetingTemplateId)
  const cameFromAccountDefaultColumn = cameFromMeetingTemplateRow && !originContext?.userId
  if (cameFromAccountDefaultColumn) return 'account'
  if (cameFromMeetingTemplateRow) return 'user'
  return templateScope === 'account' || templateScope === 'system' ? 'account' : 'user'
}
